export const workflowsApi = (client) => ({
    list: () => client.get('/api/v1/workflows').then((r) => r.data),
    get: (id) => client.get(`/api/v1/workflows/${id}`).then((r) => r.data),
    create: (body) => client.post('/api/v1/workflows', body).then((r) => r.data),
    update: (id, body) => client.patch(`/api/v1/workflows/${id}`, body).then((r) => r.data),
    remove: (id) => client.delete(`/api/v1/workflows/${id}`).then((r) => r.data),
    toggle: (id) => client.post(`/api/v1/workflows/${id}/toggle`).then((r) => r.data),
    runManually: (id, context) => client.post(`/api/v1/workflows/${id}/run`, { context }).then((r) => r.data),
    addStep: (id, body) => client.post(`/api/v1/workflows/${id}/steps`, body).then((r) => r.data),
    updateStep: (id, stepId, body) => client.patch(`/api/v1/workflows/${id}/steps/${stepId}`, body).then((r) => r.data),
    removeStep: (id, stepId) => client.delete(`/api/v1/workflows/${id}/steps/${stepId}`).then((r) => r.data),
    reorderSteps: (id, stepIds) => client.post(`/api/v1/workflows/${id}/steps/reorder`, { step_ids: stepIds }).then((r) => r.data),
    listRuns: (id) => client.get(`/api/v1/workflows/${id}/runs`).then((r) => r.data),
    listAuditLog: (id) => client.get(`/api/v1/workflows/${id}/audit-log`).then((r) => r.data),
    simulate: (body) => client.post('/api/v1/workflows/simulate', body).then((r) => r.data),
    testRun: (id, payload) => client.post(`/api/v1/workflows/${id}/test-run`, payload).then((r) => r.data),
    uploadStepFile: (id, stepId, file, onProgress) => {
        const form = new FormData();
        form.append('file', file);
        return client.post(`/api/v1/workflows/${id}/steps/${stepId}/attachments`, form, {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: (e) => { if (onProgress && e.total)
                onProgress(Math.round((e.loaded / e.total) * 100)); },
        }).then((r) => r.data);
    },
    deleteStepFile: (id, stepId, url) => client.delete(`/api/v1/workflows/${id}/steps/${stepId}/attachments`, { data: { url } }).then((r) => r.data),
});
//# sourceMappingURL=workflows.js.map